import type { TFileDropzoneFile } from '@vlabs/uikit/components/controls/file-dropzone/FileDropzone';

export async function handleLoadFile(accept = 'image/*'): Promise<TFileDropzoneFile | null> {
  return new Promise((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = accept;

    input.onchange = () => {
      const file = input.files?.[0];
      if (!file) {
        resolve(null);
        return;
      }

      const reader = new FileReader();

      reader.onload = () => {
        resolve({
          type: 'image',
          raw: file,
          binary: reader.result as string,
        });
        input.remove();
      };

      reader.onerror = () => resolve(null);

      reader.readAsDataURL(file);
    };

    input.click();
  });
}
